module.exports = __webpack_public_path__ + "static/iascone-d93f44ae3de28e68cf78a50a6f1c8180.mp4";